import Vue from 'vue';
import Vuex from 'vuex';
import apiData from './apiData.js';
import application from './application.js';
import cart from './cart.js';
import creator from './creator.js';
import invoice from './invoice.js';
import localStoragePlugin from './plugins/localStoragePlugin.js';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    apiData,
    application,
    cart,
    creator,
    invoice
  },
  plugins: [localStoragePlugin]
});
